<app-header [clicked]="clickedOutside" (changeMegaMenuCondition)="changeMenuCondition($event)"></app-header>

<section
    (click)="closeMegaMenuCondition()"
    class="tw-flex tw-justify-center tw-px-[15px] md:tw-px-[70px] tw-py-[40px] tw-w-full"
>
    <div class="tw-w-full tw-max-w-[1440px]">
        <header>
            <nav
                class="tw-px-4 md:tw-px-6 tw-gap-[10vw] tw-flex tw-items-center tw-justify-between tw-font-semibold"
            >
                <div class="">
                    <div class="tw-text-[22px] md:tw-text-4xl">
                        {{ "COMMON.GET_THE_LATEST" | translate }}
                    </div>
                </div>
            </nav>
        </header>

        <div
            class="lg:tw-hidden tw-ml-[2px] tw-mr-[5px] tw-px-[5vw] md:tw-pl-0 tw-flex tw-py-5 md:tw-py-10 tw-gap-[2rem] md:tw-gap-0 tw-flex-col md:tw-flex-row tw-items-start md:tw-items-center tw-bg-gradient-to-l tw-from-[#162EAF] tw-to-[#030826] tw-rounded-[20px] tw-mt-8"
            *ngFor="let item of showMainNews; let i = index"
        >
            <div class="sm:tw-ml-[2vw]">
                <img
                    class="tw-rounded-2xl tw-w-80 tw-h-60"
                    [src]="item.image"
                    alt="image"
                />
            </div>
            <div class="tw-px-[3vw] tw-flex-1">
                <div class="tw-flex tw-items-center tw-flex-nowrap tw-gap-3">
                    <span
                        class="tw-text-[#FFFFFF] tw-text-base tw-font-medium tw-leading-normal"
                        >{{ item.category }} </span
                    ><span
                        class="tw-text-neutral-400 tw-text-xs tw-font-medium tw-text-[#FFFFFF]"
                        >|</span
                    ><span
                        class="tw-text-[#FFFFFF] tw-text-base tw-font-medium tw-leading-normal"
                    >
                        {{ timeAgo }}</span
                    >
                </div>
                <div>
                    <div
                        class="tw-text-white tw-text-2xl tw-leading-relaxed lg:tw-text-[40px] tw-font-semibold tw-mt-[3vw] lg:tw-mt-[2vw]"
                    >
                        {{
                            item.headline?.length > 72
                                ? (item.headline | slice: 0 : 72) + "..."
                                : item.headline
                        }}
                    </div>
                </div>

                <div
                    class="tw-mt-12 tw-hidden sm:tw-block lg:tw-hidden tw-px-5"
                >
                    <a (click)="goToBlogDetails(item.id)" class="news-details">
                        <img
                            class="tw-w-10 tw-h-10"
                            src="../../../../assets/images/announcement-arrow-main.svg"
                            alt="image"
                        />
                    </a>
                </div>
            </div>
            <div
                class="tw-hidden lg:tw-block tw-px-10 xl:tw-mr-[5vw] 2xl:tw-mr-[7vw]"
            >
                <a (click)="goToBlogDetails(item.id)" class="news-details">
                    <img
                        class="tw-w-10 tw-h-10"
                        src="../../../../assets/images/announcement-arrow-main.svg"
                        alt="image"
                    />
                </a>
            </div>
        </div>

        <div
            class="tw-hidden lg:tw-flex tw-w-full tw-justify-center md:tw-py-[40px] xl:tw-py-[70px] tw-ml-[2px] tw-mr-[5px] tw-px-[5vw] md:tw-pl-0 tw-gap-[2rem] md:tw-gap-0 tw-flex-col md:tw-flex-row tw-items-start md:tw-items-center tw-bg-gradient-to-r tw-from-blue-800 tw-to-slate-900 tw-rounded-[20px] tw-mt-8"
            *ngIf="showMainNews?.length > 0"
        >
            <ng-container *ngFor="let item of showMainNews; let i = index">
                <div
                    class="md:tw-px-[70px] tw-max-w-[750px] tw-w-full tw-flex-1 tw-cursor-pointer"
                    [routerLink]="'/blogs/' + item.id"
                >
                    <div
                        class="tw-flex tw-items-center tw-flex-nowrap tw-gap-3"
                    >
                        <span
                            class="tw-text-gray-400 tw-text-base tw-font-medium tw-leading-normal"
                            >{{ item.category }}
                        </span>
                    </div>
                    <div>
                        <div
                            class="tw-text-white tw-mt-7 tw-leading-tight tw-text-2xl lg:tw-text-[40px] tw-font-semibold"
                        >
                            {{ item.headline }}
                        </div>
                    </div>

                    <div class="tw-text-gray-400 tw-mt-7">
                        {{ item.timestamp }}
                    </div>
                </div>
                <img
                    class="tw-max-w-[300px] xl:tw-max-w-[670px] tw-min-w-[310px] tw-max-h-[470px] tw-rounded-3xl tw-cursor-pointer"
                    [src]="item.image"
                    [routerLink]="'/blogs/' + item.id"
                    alt="image"
                />
            </ng-container>
        </div>

        <div class="tw-mt-[40px] tw-flex tw-flex-wrap tw-gap-[40px]">
            <ng-container *ngFor="let item of showSubNews; let i = index">
                <div
                    class="tw-w-full tw-flex-1 tw-min-w-[330px] tw-cursor-pointer"
                    [routerLink]="'/blogs/' + item.id"
                >
                    <div class="tw-w-full tw-flex tw-flex-col">
                        <div class="tw-text-gray-400">
                            {{ item.category }} | {{ item.timestamp }}
                        </div>
                    </div>
                    <img
                        class="tw-mt-5 tw-min-h-[270px] tw-rounded-2xl tw-flex tw-items-center tw-justify-center tw-bg-[#DDEEF6]"
                        [src]="item.image"
                        alt="image"
                    />
                    <div
                        class="tw-text-primary-blue-dark tw-font-semibold tw-text-[24px] tw-mt-5"
                    >
                        {{ item.headline }}
                    </div>
                </div>
            </ng-container>
        </div>

        <div
            class="tw-mt-[50px] lg:tw-mt-[100px] tw-pb-[20px] md:tw-pb-[40px] tw-border-b-[1px] tw-border-b-[#EAEAE9] tw-text-[#003A70] tw-font-semibold tw-flex tw-justify-between tw-text-[24px]"
        >
            <div>All News</div>
            <div
                class="tw-flex tw-gap-[20px] tw-justify-center tw-items-center"
            >
                <div
                    class="tw-flex tw-ml-7 tw-gap-[30px] tw-justify-center tw-items-center"
                >
                    Sort By

                    <a
                        [matMenuTriggerFor]="menu"
                        aria-label="Menu Icon"
                        class="news-sort"
                    >
                        <svg
                            class="tw-ml-2"
                            width="13"
                            height="8"
                            viewBox="0 0 13 8"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M12 1L6.5 7L1 1"
                                stroke="#003A70"
                                stroke-width="1.5"
                                stroke-linejoin="round"
                            />
                        </svg>
                        <mat-menu #menu="matMenu">
                            <button
                                mat-menu-item
                                (click)="onSortNews('latest')"
                            >
                                Latest News
                            </button>
                            <hr style="border: 1px solid #d8d8d8" />
                            <button mat-menu-item (click)="onSortNews('old')">
                                Old News
                            </button>
                        </mat-menu>
                    </a>
                </div>
            </div>
        </div>

        <div
            class="tw-flex tw-flex-col [&>*]:tw-border-b [&>*]:tw-border-b-[#EBEBEC] lg:tw-flex-row tw-mt-6 tw-flex-wrap tw-gap-[30px] [&>*]:tw-py-[40px]"
        >
            <ng-container *ngFor="let item of showAllNews; let i = index">
                <div
                    class="tw-basis-[calc(50%-1rem)] lg:tw-basis-[calc(50%-2vw)] tw-flex tw-items-center tw-justify-stretch tw-gap-[1rem] lg:tw-gap-[2vw]"
                >
                    <div class="tw-flex-shrink-0">
                        <img
                            [routerLink]="'/blogs/' + item.id"
                            class="tw-cursor-pointer tw-rounded-lg tw-w-[127px] tw-h-[90px]"
                            [src]="item.image"
                            alt="blog-image"
                        />
                    </div>

                    <div class="tw-text-sm lg:tw-text-base tw-max-h-[90px]">
                        <div
                            class="[&>*]:tw-whitespace-nowrap md:tw-hidden tw-text-sm tw-flex tw-flex-nowrap tw-gap-[5px] md:tw-gap-[10px] md:tw-mb-[1rem]"
                        >
                            <span class="tw-text-gray-400 tw-font-medium"
                                >{{ item.category }} </span
                            ><span class="tw-text-neutral-400 tw-font-medium"
                                >|</span
                            ><span class="tw-text-neutral-400 tw-font-medium">{{
                                item.timestamp
                            }}</span>
                        </div>
                        <div
                            [routerLink]="'/blogs/' + item.id"
                            class="tw-cursor-pointer tw-text-sky-900 tw-hidden md:tw-block tw-max-w-[360px] tw-w-full tw-text-lg xl:tw-text-2xl tw-font-semibold"
                        >
                            {{ item.headline | slice: 0 : 53
                            }}{{ item.headline.length > 53 ? "..." : "" }}
                        </div>

                        <div
                            [routerLink]="'/blogs/' + item.id"
                            class="tw-cursor-pointer md:tw-hidden tw-text-sky-900 tw-max-w-[360px] tw-w-full tw-text-lg xl:tw-text-2xl tw-font-semibold"
                        >
                            {{ item.headline | slice: 0 : 44
                            }}{{ item.headline.length > 44 ? "..." : "" }}
                        </div>

                        <div
                            class="tw-hidden md:tw-flex [&>*]:tw-whitespace-nowrap tw-text-sm tw-mt-2 tw-flex-nowrap tw-gap-[5px] md:tw-gap-[10px] md:tw-mb-[1rem]"
                        >
                            <span class="tw-text-gray-400 tw-font-medium"
                                >{{ item.category }} </span
                            ><span class="tw-text-neutral-400 tw-font-medium"
                                >|</span
                            ><span class="tw-text-neutral-400 tw-font-medium">{{
                                item.timestamp
                            }}</span>
                        </div>
                    </div>
                    <div
                        [routerLink]="'/blogs/' + item.id"
                        class="tw-cursor-pointer tw-hidden md:tw-flex tw-flex-grow tw-text-end tw-justify-end tw-self-start tw-mt-3"
                    >
                        <a
                            [routerLink]="'/blogs/' + item.id"
                            class="tw-cursor-pointer news-details"
                        >
                            <img
                                class="tw-w-7 tw-h-7"
                                src="../../../../assets/images/announcement-sub-arrow.svg"
                                alt="image"
                            />
                        </a>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</section>

<app-footer (click)="closeMegaMenuCondition()"></app-footer>
